import { equalsSelector, findRows } from './appsheet';

const PAYROLL_TABLES_BY_EMPLOYEE = [
    { table: 'THOA_THUAN_CONG_LUONG', label: 'thỏa thuận lương' },
    { table: 'CT_BANG_CONG_LUONG', label: 'bảng lương' },
    { table: 'PHIEU_UNG_LUONG', label: 'phiếu ứng lương' },
];

/**
 * Các loại dữ liệu lương đang trỏ tới SỐ HĐ này. Dữ liệu lương gắn nhân sự bằng SỐ HĐ, nên đổi
 * hoặc xóa SỐ HĐ của người đã có lương sẽ làm mồ côi các dòng đó.
 *
 * Lỗi khi đọc (ví dụ chưa tạo bảng lương trên AppSheet) được ném ra để nơi gọi chặn thao tác:
 * không kiểm tra được thì không cho đổi, còn hơn làm mất liên kết mà không ai biết.
 */
export async function findPayrollUsage(soHd) {
    const results = await Promise.all(PAYROLL_TABLES_BY_EMPLOYEE.map(async ({ table, label }) => {
        const rows = await findRows(table, equalsSelector(table, 'SỐ HĐ', soHd));
        return rows.length ? `${rows.length} ${label}` : null;
    }));
    return results.filter(Boolean);
}
